var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenterbite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.3,218.3c-0.5,6.7-1,13.3-1.5,20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.8,207.3c-3.6,7.5-10.9,7-17.5,7.9c-2.5,0.3-5,0-7.5,0.1c-4,0.1-7-1.6-9-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.8,232.8c-2.3,1.8-4.6,3.8-7,5.5c-5.6,3.7-10.5,1.7-10.8-5c-0.3-6.1-1.1-12.4,0.8-18.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.8,239.8c2.4,3.4,3.6,7.6,7.5,10.1c4.4,2.7,8.4,2.6,12-1c2.6-2.5,3.9-6.9,5.5-10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.8,237.8c-1.4,3-3.5,7.1-6,9.5c-6.4,6.4-11.8,6-17-1.6c-1.3-1.8-2-4-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.8,216.3c0.6,6.8-1.2,13.8,1,20.5c0.2,0.6-0.1,1.7-0.5,1.9c-4.8,2.4-7.5,7.6-13.4,8.7 c-6.5,1.2-8.8,0.7-11-5.7c-3.6-10.5-3-20.8,3-30.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.8,180.3c-3-2.8-6-5.7-9-8.5c-6.3-5.9-10.4-4.8-13,3.5c-0.2,0.6-0.6,1-1,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.8,211.3c4.6,5,4.1,11.5,4.8,17.5c0.4,3.3,2.3,4.7,4.2,6.4c2.7,2.5,5.9,4.6,9.5,4.9c2.6,0.2,4-2.1,4.5-4.8 c1.2-7.1,1.7-14.1-0.5-21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M319.8,176.8c-0.6-0.5-0.8-1.2-1.1-2c-2.7-7.4-5.4-9.7-12.4-3.5c-3.3,2.9-6.3,6-9.5,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,208.3c-1.6,4.5-1.5,9.3-2,14c-0.3,2.6,0.2,5.4-0.1,8c-0.4,3.3,0.5,6.4,3.2,7.8c1.9,1,4.8,0.5,6.9-1.3 c1.1-0.9,2.3-1.7,3.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8,207.3c-0.9,6-2.6,11.8-1.5,18c0.8,4.4,3.3,6.2,7.5,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.3,208.3c3.5,5.6,9.1,6.7,15,7c3.3,0.2,6.7-0.1,10,0.1c4,0.2,6.6-1.8,8.5-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.3,207.8c4.6-3.4,5.2-8.4,5.4-13.5c0.2-5.5,0-11,0.1-16.5c0.1-3.2-0.8-6.1-3.6-7.4 c-2.5-1.1-4.5,1.2-6.5,2.8c-4,3.2-5.6,6.9-5,12.1c0.5,4.5-0.1,9,0.2,13.5c0.2,4-0.9,7.5-2.6,11c-2.9,5.9-8.9,7.8-14.5,4.5 c-1.4-0.8-2.7-1.9-4-3c-2.6-2.2-3.9-4.7-3.1-8.5c2-9.2,0.6-18.3-0.9-27.5c-0.4-2.6-1.7-4.9-3.1-6.9c-2.5-3.7-5.5-3.9-10.4-2.1 c-7.7,2.9-12.3,9.4-17.5,14c0,7.5,0.6,14.6-0.2,21.5c-1,8.4-8.5,14.9-17.8,15.4c-8.1,0.4-16.5,1.6-24.4-1c-4.7-1.5-8.5-1-13.1,0.3 c-5.6,1.6-11.7,3-18,0.9c-3.1-1-6.6-0.1-10-1c-9.4-2.6-14.5-8.6-14.5-18.1c0-5.8-0.3-11.7,0.5-17.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.8,216.3c-0.5,6.7,1,14.4-1,21c-0.2,0.6,0.1,0.6,0.5,0.9c4.9,4.3,9.3,9.5,16.5,10c5.7,0.4,7.9-4.2,9-9.5 c0.3-1.7,0.8-4.5,2-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M337.8,207.3c1.3,5.6,1.8,11.3,1.4,17c-0.4,5.4-1.5,6.1-7.4,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.3,175.3c-7.3-3.1-7.2-3.1-8.5,4.5c-0.2,1.2-1,2.4-0.9,3.5c0.5,6.3,0.8,12.8,2.1,19c1,4.8,4.8,5.4,9.9,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.3,218.3c0.3,5.8-0.1,11.9,1.2,17.5c1.7,7.3,5.2,14.2,11.8,18.5c3.3,2.1,8.4-0.1,11.5-4.4 c3-4.2,5.3-10.2,7-15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.8,182.8c-2.8-5.9-4.4-12.2-9.4-17.1c-7.4-7.2-20-6.3-27.1,0.1c-4.5,4-7.9,8.6-10.5,14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.3,204.3c2.1,2.4,4.7,3.7,8.3,2.7c1.4,6.5,2.1,12.3,2.2,18.3c0,2.7,0.5,5.4-0.1,8c-1.2,5.2-4.7,6.5-9.4,4 c-1.6-0.8-3-2-4.5-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.3,204.8c5.8,3.1,8,2.3,9.4-4c1.8-7.9,2.6-15.9,1.1-24c-0.8-4.2-3-4.6-8.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.8,184.3c0,15-0.1,30,0,45c0.1,9.3,3.8,17.2,10,24c2,2.2,7.4,2.2,10.4-0.5c4-3.5,7.6-9,9.5-14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.8,179.8c-2.4-5.1-5.2-9.9-9.5-13.5c-13-10.8-28.1-6.4-34.5,8.5c-1.1,2.6-2,5.3-3,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.3,180.3c-3.9-5-8.6-9.1-14-12.5c-8.9-5.7-13.2-1.7-15.6,5c-2.8,7.9-2.5,16-2.8,24 c-0.1,3.3,1,6.7,1.7,10.7c-3.4,2.9-6.4,6.8-12.2,8.1c-4,0.9-6.3-0.7-7.9-2.5c-2.9-3.4-4.9-7.5-4.7-12.4c0.2-5-0.4-10.1,0.2-15 c0.7-6-1.6-10-6.1-13.6c-4.3-3.4-8.5-2.4-8.8,3.1c-0.5,8-1.2,16.1,0.4,24c1.9,9.1,5.7,10.3,13.9,5.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterbite);
export default __webpack_public_path__ + "static/media/centerbite.e60b46c76b6c23b374aeafd96fd27452.svg";
export { ForwardRef as ReactComponent };